module.exports = __webpack_public_path__ + "img/StorageSpaces.015fd538.svg";